import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { Observable } from 'rxjs';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'CTCNetwork';
  isLoggedIn$: Observable<boolean>;
  isHomePage: boolean = false;
  isLoginPage: boolean = false;

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router
  ) {
    this.initializeApp();
    this.isLoggedIn$ = this.authService.isLoggedIn$;
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isHomePage = event.urlAfterRedirects === '/';
      this.isLoginPage = event.urlAfterRedirects === '/login';
    });
  }

  initializeApp(): void {
    this.translate.addLangs(['en', 'es', 'fr']);
    const savedLang = localStorage.getItem('language') || 'fr';
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }

  ngOnInit(): void {
    // Forzar tema light de PrimeNG
    document.documentElement.setAttribute('data-p-theme', 'aura-light');
    document.body.classList.remove('dark');
    document.body.classList.add('light');
    
    // También establecer en localStorage para persistencia
    localStorage.setItem('p-theme', 'aura-light');
  }

} 